module.exports = __webpack_public_path__ + "static/media/ico-tel-menu_new.cc82647f.svg";